import React, {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Table, {atomTableCellPadding} from '@s-ui/react-atom-table'
import Context from '@s-ui/react-context'

import BasicListItem from './BasicListItem.js'
import IconListItem from './IconListItem.js'

const BASE_CLASS = 'mt-ListModelDetails'

const DEFAULT_EMPTY_FIELD = '-'

const getTableRow = (array, isMobile) => {
  const [label, value] = array
  const tableRow = [
    {
      content: (
        <div className={`${BASE_CLASS}-table--vertical`}>
          <span className={`${BASE_CLASS}-tableItem`}>{label}</span>
          {isMobile && <span className={`${BASE_CLASS}-tableItem--strong`}>{value}</span>}
        </div>
      ),
      isNowrap: false
    }
  ]
  !isMobile &&
    tableRow.push({
      content: <span className={`${BASE_CLASS}-tableItem--strong`}>{value}</span>,
      isNowrap: false
    })
  return tableRow
}

export const SpecsList = ({hasIconList, specifications, isTable = false}) => {
  const {i18n, domain} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const listClass = cx(`${BASE_CLASS}-list`, {
    [`${BASE_CLASS}-listIcon`]: hasIconList
  })

  const getSpecificationsList = () =>
    specifications.map(({key, keyParams, value, params, icon}, index) => {
      const listItem = i18n.t(key, {...keyParams})
      const itemValue = i18n.t(value, params) || DEFAULT_EMPTY_FIELD

      if (isTable) {
        return getTableRow([listItem, itemValue], isMobile)
      }

      return (
        <li className={`${BASE_CLASS}-listItem`} key={index} data-testid={key}>
          {hasIconList ? (
            <IconListItem baseClass={BASE_CLASS} icon={icon} itemValue={itemValue} listItem={listItem} />
          ) : (
            <BasicListItem itemValue={itemValue} listItem={listItem} />
          )}
        </li>
      )
    })

  if (isTable)
    return (
      <div className={`${BASE_CLASS}-table`}>
        <Table body={getSpecificationsList()} fullWidth cellPadding={atomTableCellPadding.l} zebraStriped />
      </div>
    )
  return <ul className={listClass}>{getSpecificationsList()}</ul>
}

SpecsList.propTypes = {
  isTable: PropTypes.bool,
  hasIconList: PropTypes.bool,
  specifications: PropTypes.object
}
